export default __webpack_public_path__ + "media/images/linkedin-efa3abb0fe4b0f408bf25be153867594.svg";